import * as React from 'react';
import { DEFAULT_COUNTRY } from './setup.esm.js';

var CountryLocationContext = React.createContext({
    countryCode: DEFAULT_COUNTRY,
});

export { CountryLocationContext };
//# sourceMappingURL=context.esm.js.map
